import React, { useEffect } from 'react';
import './App.less';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import RouterGuard from './Routes/RouteGuard';
import configureAppStore from '../configureStore';
import arEG from 'antd/es/locale/ar_EG';
import enUS from 'antd/es/locale/en_US';
import { useTranslation } from "react-i18next";
import DesignSwitchModal from './DesignSwitchModal/DesignSwitchModal';

const store = configureAppStore();

function App() {
    const { i18n } = useTranslation();
    const defaultLocale = i18n.dir() === 'rtl' ? arEG : enUS;
    document.body.dir = i18n.dir();

    // const [isModalVisible, setIsModalVisible] = React.useState(false);

    // useEffect(() => {
    //     const choice = localStorage.getItem("useOldDesign");
    //     console.log("choice: ", choice)
    //     if (choice === "true") {
    //         // redirect to old design if previously chosen
    //          window.location.href = "https://eparts.mcmotor.ps/login";
    //     } else if (choice === "false") {
    //         // previously chose new design, hide modal
    //         setIsModalVisible(false);
           
    //     } else {
    //         // first visit, show modal
    //         setIsModalVisible(true);
    //     }
    // }, []);

    const handleSwitchToOld = () => {
        // user chooses old design
        localStorage.setItem("useOldDesign", "true");
        window.location.href = "https://eparts.mcmotor.ps/login"; // redirect immediately
    };

    const handleStay = () => {
        // user chooses new design
        localStorage.setItem("useOldDesign", "false");
        // setIsModalVisible(false);
    };

    return (
        <Provider store={store}>
            <BrowserRouter>
                <ConfigProvider locale={defaultLocale}>
                    <RouterGuard />
                    {/* <DesignSwitchModal
                        isOpen={isModalVisible}
                        onSwitch={handleSwitchToOld}
                        onClose={handleStay}
                    /> */}
                </ConfigProvider>
            </BrowserRouter>
        </Provider>
    );
}


export default App;
